
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_REQUEST_IS_MALFORMED,
	WS_PROCESS_MESSAGE_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import customerFlowMapper from './mappers/customerFlowMapper';
import { publishAndAwait } from '../../../app/coreSlice';

const {
	toDTO,
	fromDTO,
} = customerFlowMapper || {};

const updateCustomer = async (customer) => {
	console.log('updateCustomer - customer: %o', customer);

	if (typeof customer === 'undefined') {
		throw errorFactory(WS_REQUEST_IS_MALFORMED);
	}

	let customerDTO = customer;

	if (!customer.updateAgent){
		customerDTO = toDTO(customer);
	};

	delete customer.updateAgent;

	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'CUSTOMER',
			subType: 'UPDATE',
			message: {
				...customerDTO,
			},
		},
	});

	const { processMessage, error } = request.response;

	if (!processMessage) {
		throw errorFactory(WS_PROCESS_MESSAGE_IS_MALFORMED);
	}

	if (error) {

		const {
			description,
			code,
			tag,
		} = processMessage;

		throw new NGError({
			message: description,
			code,
			tag,
		});
	}

	const customerModel = fromDTO(processMessage);

	return customerModel || null;

};

export default updateCustomer;